import { connect } from 'react-redux'
import * as R from 'ramda'

import Cpu from 'components/form/defaultCpu/index'
import {
  revisionSelector,
  currentRevisionSelector
} from './selectors'


const withConnect = () => {
  const mapStateToProps = state => {
    return {
      revision: revisionSelector(state),
      currentRevision: currentRevisionSelector(state)
    }
  }

  return connect(mapStateToProps)
}

export { default as Cpu } from 'components/form/defaultCpu/index'
export {
  withConnect
}

export default R.curry((path, id) => R.compose(
  withConnect(path, id)
)(Cpu))
